












import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { EvalSettingSimple } from '@/models/evalSetting/eval-setting-simple';
import { GPageBase } from '@/mixins';

@Component({
  name: 'GExamListTitleInput',
  computed: {},
  methods: {},
})
export default class GExamListTitleInput extends Mixins(GPageBase) {
  tempTitle: string = ''; // タイトル編集時の一時保存用(Enter押下時にリセットされる)

  @Prop() evalSettingSimple: EvalSettingSimple;

  mounted() {}

  handleFocus() {
    this.tempTitle = this.evalSettingSimple.title;
  }

  handleEditTitleBlur(evalSettingSimple: EvalSettingSimple) {
    if (evalSettingSimple.title === '') {
      evalSettingSimple.title = this.tempTitle;
      return;
    } else if (evalSettingSimple.title === this.tempTitle) {
      return;
    }
    const beforeTitle: string = this.tempTitle;

    this.$emit('handleUpdateTitle', this.evalSettingSimple, beforeTitle);
  }
}
